module.exports = __webpack_public_path__ + "img/mobile-marketing-rafiki.528d8f1e.svg";